import { useState } from 'react'
import { IconContext } from 'react-icons'
import { Link } from 'react-router-dom'
import '../SideBar-right/SidebarMobile.css'
import imgOpen from '../../Images/imgButtonEsquerda/imgOpen.svg'
import logoSub from '../../Images/logoQuadrados-removebg-preview.png'

function SidebarMobile() {
  const [sidebar, setSidebar] = useState(false)
  const permissoes = localStorage.getItem('permissoes')
  let permissao = []
  if (permissoes) {
    permissao = JSON.parse(permissoes)
  } else {
    permissao = [
      {
        perModulo: 'ACECAD',
        perAcesso: 1
      },
      {
        perModulo: 'ACELOC',
        perAcesso: 1
      },
      {
        perModulo: 'ACEPES',
        perAcesso: 1
      },
      {
        perModulo: 'ACEAUD',
        perAcesso: 1
      },
      {
        perModulo: 'ACETXT',
        perAcesso: 1
      },
      {
        perModulo: 'ACEUNI',
        perAcesso: 1
      },
      {
        perModulo: 'ACEGPU',
        perAcesso: 1
      },
      {
        perModulo: 'ACEFUN',
        perAcesso: 1
      },
      {
        perModulo: 'ACEREL',
        perAcesso: 1
      },
      {
        perModulo: 'ACETPD',
        perAcesso: 1
      },
      {
        perModulo: 'ACEDOC',
        perAcesso: 1
      }
    ]
  }
  // let ACECAD = permissao.find((element: any) => {
  //   return element.perModulo === 'ACECAD'
  // })
  // let ACELOC = permissao.find((element: any) => {
  //   return element.perModulo === 'ACELOC'
  // })
  let ACEPES = permissao.find((element: any) => {
    return element.perModulo === 'ACEPES'
  })
  // let ACEAUD = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEAUD'
  // })
  let ACETXT = permissao.find((element: any) => {
    return element.perModulo === 'ACETXT'
  })
  let ACEUNI = permissao.find((element: any) => {
    return element.perModulo === 'ACEUNI'
  })
  let ACEGPU = permissao.find((element: any) => {
    return element.perModulo === 'ACEGPU'
  })
  let ACEFUN = permissao.find((element: any) => {
    return element.perModulo === 'ACEFUN'
  })
  // let ACEREL = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEREL'
  // })
  let ACETPD = permissao.find((element: any) => {
    return element.perModulo === 'ACETPD'
  })
  // let ACEDOC = permissao.find((element: any) => {
  //   return element.perModulo === 'ACEDOC'
  // })
  const showSidebar = () => setSidebar(!sidebar)
  return (
    <>
      <IconContext.Provider value={{ color: 'hsl(0, 0%, 100%)' }}>
        <div className="navbar">
          <button onClick={showSidebar} className="abrirSubMenu">
            <img src={imgOpen} alt="" />
          </button>
          <nav className={sidebar ? 'nav-subMenu1' : 'nav-active'}>
            <div className="divLogo">
              <img className="logoSub" src={logoSub} alt="logoSub" />
            </div>
            <ul className="nav-menu-items" onClick={showSidebar}>
              <li className="navbar-toggle">
                <div className="close-background">
                  <div className="navBarMenu-logo"></div>
                </div>
                <aside className="MobileProfileDireita">
                  {!!ACEUNI.perAcesso ? (
                    <Link to="/Unidades">
                      <button className="MenuFlex1">Unidades</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACEPES.perAcesso ? (
                    <Link to="/SubMenuPessoas">
                      <button className="MenuFlex2">Pessoas</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACEGPU.perAcesso ? (
                    <Link to="/SubMenuGruposUsuarios">
                      <button className="MenuFlex3">Grupos de Usuários</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACEFUN.perAcesso ? (
                    <Link to="/SubMenuFuncaoEPermissao">
                      <button className="MenuFlex4">Funções</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACETXT.perAcesso ? (
                    <Link to="/Classificacao">
                      <button className="MenuFlex7">Classificações</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACETXT.perAcesso ? (
                    <Link to="/Texto">
                      <button className="MenuFlex5">Textos de Classificação</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACETPD.perAcesso ? (
                    <Link to="/SubMenuTipoDocumento">
                      <button className="MenuFlex6">Tipos de Documentos</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}
                  {!!ACEUNI.perAcesso ? (
                    <Link to="/Checklist">
                      <button className="MenuFlex6">Checklist</button>
                    </Link>
                  ) : (
                    <li></li>
                  )}

                </aside>
              </li>
            </ul>
            <button onClick={showSidebar} className="fecharSubMenu">
              <img src={imgOpen} alt="" />
            </button>
          </nav>
        </div>
      </IconContext.Provider>
    </>
  )
}

export default SidebarMobile
